import { Box } from '@/common/components';
import { styled } from '@/stitches.config';

export const StyledProccessLoaderContainer = styled(Box, {
  width: '60%',
  margin: '$12 auto',
});

export const StyledActionsContainer = styled(Box, {
  display: 'flex',
  flexDirection: 'column',
  paddingTop: '$4',
  gap: '$4',
  width: '60%',
  margin: 'auto',
});
